export default "__VITE_ASSET__CeSa8Uq6__"